<template>
	<component :is="view" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore, authUser } from '../store';
import BeschwerdeDetail from '@/views/BeschwerdeDetail.vue';
import BeschwerdeDetailPublic from './BeschwerdeDetailPublic.vue';
import BeschwerdeDetailWerberatVorstand from './BeschwerdeDetailWerberatVorstand.vue';

export default defineComponent({
	name: 'BeschwerdenWrapper',
	components: {
		BeschwerdeDetail,
		BeschwerdeDetailPublic,
	},
	setup() {
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);
		const user = computed(() => store.state.user);
		const isLoggedIn = loggedin.value && user.value;

		const view = computed(() => {
			if (!isLoggedIn) {
				return BeschwerdeDetailPublic;
			}

			const authUserRoles = authUser.value.roles.map((role) => role.name);

			if (
				authUserRoles.includes('Vorstand') ||
				authUserRoles.includes('Werberat') ||
				authUserRoles.includes('Junger Werberat') ||
				authUserRoles.includes('Kleiner Senat A') ||
				authUserRoles.includes('Kleiner Senat B')
			) {
				return BeschwerdeDetailWerberatVorstand;
			}

			return BeschwerdeDetail;
		});

		return {
			view,
		};
	},
});
</script>
